import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type WorkflowResourceV3 = OpalApiComponent<'V3', 'workflow'>

export const workflowResourceFactory: Factory<WorkflowResourceV3> =
  Factory.define<WorkflowResourceV3>(() => {
    const now = new Date().toISOString()
    return {
      id: uuidV4(),
      type: 'workflow',
      attributes: {
        created_at: now,
        updated_at: now,
        progress: 'not_started',
        is_approved: false,
      },
      meta: {
        latest_active_stage: null,
        completed_stages: 0,
        stage_type_count: { approval: 0, task: 0, circuit_breaker: 0 },
      },
      relationships: {
        context: { data: null },
        current_stage: { data: null },
        created_by_user: { data: { id: uuidV4(), type: 'user' } },
        stages: { data: [] },
      },
    } satisfies WorkflowResourceV3
  })
